import axios from 'axios';
import { LOGIN_PATH, PUBLIC_APP_TAB_PATHS } from '../components/LegalLinks';
import { usePermissionStore } from '../stores/permissionStore';
import getToken from './GetToken';

let sessionExpiryHandled = false;

export function parseJwtPayload(token) {
    if (!token) {
        return null;
    }

    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) {
            return null;
        }

        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(base64));
    } catch {
        return null;
    }
}

export function isTokenExpired(token) {
    const payload = parseJwtPayload(token);
    if (!payload?.exp) {
        return true;
    }

    const expiresAt = new Date(0);
    expiresAt.setUTCSeconds(payload.exp);
    return expiresAt.getTime() <= Date.now();
}

export function isStoredSessionExpired() {
    const token = getToken();
    if (!token) {
        return true;
    }

    return isTokenExpired(token);
}

export function clearAuthSession(dispatch) {
    sessionStorage.removeItem('auth');
    dispatch({ type: 'IS_AUTHENTICATED', payload: false });
    dispatch({ type: 'LOGGED_OUT', payload: false });
    usePermissionStore.getState().clearPermissions();
}

export function resetSessionExpiryGuard() {
    sessionExpiryHandled = false;
}

export function handleSessionExpired(store, { redirect = true } = {}) {
    if (sessionExpiryHandled) {
        return;
    }

    sessionExpiryHandled = true;
    clearAuthSession(store.dispatch);

    if (redirect && !PUBLIC_APP_TAB_PATHS.includes(window.location.pathname)) {
        window.location.assign(LOGIN_PATH);
    }
}

function requestHadAuthHeader(config) {
    const headers = config?.headers;
    if (!headers) {
        return false;
    }

    return Boolean(headers.Authorization ?? headers.authorization);
}

export function setupAxiosAuthInterceptor(store) {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401 && requestHadAuthHeader(error.config)) {
                handleSessionExpired(store);
            }

            return Promise.reject(error);
        }
    );
}
